<template>
    <v-app class="layout-main">
        <!-- drawer -->
        <!-- v-if="
            $route.name !== 'ErrorPage' && $route.name !== 'EvaluationByUrl'
        " -->
        <v-navigation-drawer
            app
            clipped
            light
            color="white"
            class="roma-drawer elevation-3"
            :mini-variant="drawerState"
            :v-model="drawerState"
            :temporary="false"
            v-if="false"
            mini-variant-width="100"
        >
            <!-- options list -->
            <v-list nav rounded>
                <!-- items -->
                <v-list-item
                    link
                    v-for="(link, i) in options"
                    :key="i"
                    :to="{ name: link.to }"
                    exact-active-class="roma-active"
                    :class="link.customClasses"
                    color="grey"
                    :ripple="{ class: 'prueba-frederick' }"
                >
                    <v-list-item-action class="drawer-item">
                        <img :src="link.icon" alt class="default" />
                        <img :src="link.iconActive" class="active" alt />
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="roma-cabin-bold">{{
                            link.title
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <!-- group -->
                <!-- <v-list-group
                    link
                    v-for="(link, i) in options"
                    :key="i"
                    :to="{ name: link.to }"
                    exact-active-class="roma-active"
                    :class="link.customClasses"
                >
                    <template v-slot:activator>
                        <v-list-item-action class="drawer-item">
                            <img :src="link.icon" alt class="default" />
                            <img :src="link.iconActive" class="active" alt />
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title class="roma-cabin-bold">{{
                                link.title
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </template>
                    <v-list-item link>
                        <v-list-item-title>Titulo</v-list-item-title>
                    </v-list-item>
                </v-list-group> -->
            </v-list>
        </v-navigation-drawer>

        <!-- temporary drawer -->
        <v-navigation-drawer
            v-model="left"
            v-if="false"
            class="roma-drawer"
            fixed
            temporary
        >
            <v-row class="justify-space-around justify-sm-end">
                <v-col cols="auto" sm="auto">
                    <v-btn
                        color="white"
                        fab
                        class="close-btn mx-5 d-none d-sm-block"
                        @click="left = !left"
                        small=""
                    >
                        <img src="@/assets/images/close.svg" alt="" />
                    </v-btn>
                    <!-- avatar -->
                    <v-avatar
                        color="white"
                        size="53"
                        class="d-block d-sm-none mx-5"
                    >
                        <img
                            src="@/assets/images/avatar_default.png"
                            alt="John"
                        />
                    </v-avatar>
                </v-col>
                <v-col class="d-block d-sm-none">
                    <p class="font-weight-bold">Camilo Navas</p>
                    <p class="">4to Básico A</p>
                </v-col>
            </v-row>

            <!-- options list -->
            <v-list nav rounded>
                <!-- items -->
                <v-list-item
                    link
                    v-for="(link, i) in options"
                    :key="i"
                    :to="{ name: link.to }"
                    exact-active-class="roma-active"
                    :class="link.customClasses"
                >
                    <v-list-item-action class="drawer-item">
                        <img :src="link.icon" alt class="default" />
                        <img :src="link.iconActive" class="active" alt />
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="roma-cabin-bold">{{
                            link.title
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <!-- header -->
        <RomaHeader :dpDrawer="ToggleDrawer" :dpTemporary="toggleTemporary" />

        <!-- content -->
        <v-main class="layout-main">
            <router-view></router-view>
        </v-main>
    </v-app>
</template>

<script>
import RomaDrawer from "./RomaDrawer.vue";
import RomaHeader from "./RomaHeader.vue";
import { mapActions, mapGetters } from "vuex";
export default {
    title() {
        return `Prueba`;
    },
    created() {
        document.title = "Roma Evaluaciones";
    },
    data() {
        return {
            drawerState: null,
            left: false,
            options: [
                {
                    title: "Evaluaciones",
                    icon: require("@/assets/icons/icon-in-review.svg"),
                    iconActive: require("@/assets/icons/icon-in-review-active.svg"),
                    to: "Evaluations",
                    customClasses: ""
                },
                {
                    title: "Por Realizar",
                    // icon: require("@/assets/icons/my_class_icon.svg"),
                    // iconActive: require("@/assets/icons/online-course.svg"),
                    to: "inReview",
                    customClasses: "no-icon"
                },
                {
                    title: "Realizadas",
                    // icon: require("@/assets/icons/my_class_icon.svg"),
                    // iconActive: require("@/assets/icons/online-course.svg"),
                    to: "reviewed",
                    customClasses: "no-icon"
                }
            ]
        };
    },
    components: {
        RomaHeader
    },
    methods: {
        ToggleDrawer() {
            this.drawerState = !this.drawerState;
        },
        toggleTemporary() {
            this.left = !this.left;
        },
        ...mapActions({
            actionToggleDrawer: "toggleDrawer"
        })
    },
    watch: {
        drawer(val) {
            this.actionToggleDrawer(val);
        }
    }
};
</script>
<style lang="scss">
.layout-main {
    .roma-drawer {
        &.v-navigation-drawer--mini-variant {
            .v-list-item {
                width: 60px;
                margin-left: auto;
                margin-right: auto;
            }
            .drawer-item {
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 0 !important;
                img {
                }
            }
        }
    }
}
</style>
